<template>
  <div class="customer-select-wrapper">
    <select-container
      :title="selectedCustomer ? selectedCustomer.fullName : 'בחירת לקוח'"
      :subtitle="selectedCustomer ? selectedCustomer.phoneNumber : 'בחירת לקוח עבור התור'"
      icon="pi-user"
      :fullName="selectedCustomer ? selectedCustomer.fullName : undefined"
      @click="containerClick" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import type { ICustomer } from '@torim-app/types';
import { SelectContainer, useDrawer } from '@torim-app/shared-components';
import SelectCustomerDrawerContent from './SelectCustomerDrawerContent.vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: false
  }
});

const emit = defineEmits(['customerSelected']);
const { openDrawer, closeDrawer } = useDrawer();

const showDrawer = ref<boolean>(false);

const selectedCustomer = ref<Pick<ICustomer, 'id' | 'fullName' | 'tags' | 'loyalty' | 'smsOptedOut' | 'phoneNumber'> | undefined>();

const onCustomerSelected = (customer: Pick<ICustomer, 'id' | 'fullName' | 'tags' | 'loyalty' | 'smsOptedOut' | 'phoneNumber'>) => {
  selectedCustomer.value = customer;
  emit('customerSelected', customer);
  showDrawer.value = false;
};

const containerClick = () => {
  setTimeout(() => {
    openDrawer(SelectCustomerDrawerContent, {
      initialCustomerId: selectedCustomer.value?.id,
      onCustomerSelected: onCustomerSelected,
      onCancel: () => {
        closeDrawer();
      }
    }, {
      title: 'בחירת לקוח',
      noPadding: true
    });
  }, 300);
};
</script>

<style scoped>
.customer-select-wrapper {
  width: 100%;
}
</style>
